/* eslint-disable no-unused-vars */
import Vue from 'vue';
import { Toast, Dialog } from 'cube-ui';

Vue.use(Toast);
Vue.use(Dialog);

const Alert = {
  showAlert: (title, content) => {
    Dialog.$create({
      type: 'alert',
      title,
      content,
      icon: 'cubeic-alert',
    }).show();
  },
  showDialog: (title) => {
    Dialog.$create({
      type: 'confirm',
      content: title,
      icon: 'cubeic-alert',
      confirmBtn: {
        text: '确定',
        active: true,
        disabled: false,
      },
      cancelBtn: {
        text: '取消',
        active: false,
        disabled: false,
      },
      onConfirm: () => {
      },
    }).show();
  },
};

const toast = {
  info: (msg) => {
    Toast.$create({
      time: 3 * 1000,
      txt: msg,
      type: 'correct',
    }).show();
  },
  warn: (msg) => {
    Toast.$create({
      time: 3 * 1000,
      txt: msg,
      type: 'warn',
    }).show();
  },
  error: (msg) => {
    Toast.$create({
      time: 3 * 1000,
      txt: msg,
      type: 'error',
    }).show();
  },
};

const UI = {
  Alert,
  Toast: toast,
};

export default UI;



// WEBPACK FOOTER //
// ./src/utils/ui.js